'use client'

import Link from 'next/link'
import { CHARACTER_THEMES } from '@/lib/character-themes'
import type { PublicChatClosingCard } from '@/lib/free-santa'
import { cn } from '@/lib/utils'
import type { ClosingOffer } from './public-chat-turns'
import { SignupLink } from './signup-link'

const SECONDARY = 'underline underline-offset-2'

/**
 * Cierre del chat público (US-2), sobre el compositor, compacto como los avisos
 * del chat del niño (en móvil comparte pantalla con el panel y la tarjeta de
 * llamar): el alta como CTA principal y, salvo tras buscar a un adulto
 * (`signupOnly`, guarda 9), la videollamada y el vídeo como enlaces.
 */
export function ClosingCard({ labels, offer }: { labels: PublicChatClosingCard; offer: ClosingOffer }) {
  return (
    <div data-testid="public-chat-closing" className="readable-body mx-4 mb-2 rounded-2xl border border-accent/40 bg-accent/10 px-4 py-3 text-center">
      <h2 className="font-christmas text-lg font-bold text-accent">{labels.title}</h2>
      {offer === 'full' && <p className="text-xs text-muted-foreground">{labels.body}</p>}
      <SignupLink
        href={labels.signup.href}
        placement="closing_card"
        cta="signup"
        className={cn(
          'mt-2 flex min-h-11 w-full items-center justify-center rounded-2xl px-4 py-2 text-base font-semibold',
          CHARACTER_THEMES.santa.videoCall.ctaButton
        )}
      >
        {labels.signup.label}
      </SignupLink>
      {offer === 'full' && (
        <div className="mt-2 flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-muted-foreground">
          <SignupLink href={labels.call.href} placement="closing_card" cta="call" className={SECONDARY}>
            {labels.call.label}
          </SignupLink>
          <Link href={labels.video.href} className={SECONDARY}>
            {labels.video.label}
          </Link>
        </div>
      )}
    </div>
  )
}
